var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastmarkets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.39 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #6f0791;\n      }\n\n      .st1 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.42,32.22l-.7.7v3.89l.7.7h5.96l.7-.7v-3.89l-.7-.7h-5.96ZM18.42,24.92l-.7.7v3.89l.7.7h11.26l.7-.7v-3.89l-.7-.7h-11.26ZM18.42,17.52l-.7.7v3.89l.7.7h16.56l.7-.7v-3.89l-.7-.7h-16.56Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 163,
    height: 56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastmarkets);
export default __webpack_public_path__ + "static/media/Fastmarkets.70edbf109af55df7a317a9196fb4df00.svg";
export { ForwardRef as ReactComponent };